const formatter = new Intl.NumberFormat("en");
/**
 * Formats an integer with commas for readability.
 * @param {number} num - The integer to format.
 * @returns {string} The formatted integer as a string.
 */
export const formatInteger = (num) => {
  return formatter.format(num);
};
